import { render, staticRenderFns } from "./IconCoinEuroLight.vue?vue&type=template&id=f63b77f0&"
import script from "./IconCoinEuroLight.vue?vue&type=script&lang=js&"
export * from "./IconCoinEuroLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports